var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"issues-list-collection-container"},[_c('div',{staticClass:"issues-list-collection"},_vm._l((_vm.issuesList),function(issue,index){return _c('IssuesListItem',{key:index,attrs:{"issue":issue}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }